import React, { useEffect, useState } from "react";
import { Tabs, Form, Row, Col, Checkbox, Collapse } from "antd";
import NavBar from "../../communs/NavBar";
import SecondaryButton from "../../../biblio/Buttons/SecondaryButton";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import folder from "../../../assets/icons/folder-icon.svg";
import dollar from "../../../assets/icons/money-icon.svg";
import dollarWhite from "../../../assets/icons/tabs-icons/money-icon-w.svg";
import location from "../../../assets/icons/location-icon.svg";
import locationWhite from "../../../assets/icons/tabs-icons/location-icon-w.svg";
import users from "../../../assets/icons/users-icon.svg";
import usersWhite from "../../../assets/icons/tabs-icons/users-icon-w.svg";
import user from "../../../assets/icons/tabs-icons/user-icon-df.svg";
import userWhite from "../../../assets/icons/tabs-icons/user-icon-w.svg";
import tab from "../../../assets/icons/tab-click-icon.svg";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  getAllDiseaseType,
  getAllAcademicLevels,
  getAllAcademicsYears,
  getAllAcademicsPerformance,
  getAllEducationalInstitutionTypes,
  getAllIdentificationTypes,
  getAllNationality,
  getAllMaritalStatus,
  getAllOrphansBeneficiaryInfo,
  getAllHealthStates,
  getAllGuardianRelationships,
  getAllDisabilityTypes,
  toUpdateMotherBankInfo,
  toUpdateGuardianInfo,
  toUpdateHousingInfo,
  getAllHousingTypes,
  getAllHousingStates,
  toUpdateAssistancesInfo,
  toUpdateDocumentsInfo,
  toUpdateOrphansInfo,
  toUpdateLiabilityInfos,
} from "../../../apis/actions/recipient.actions";
import { showNotitfication } from "../../../components/utils/utils";
import { toGetAllBanks } from "../../../apis/actions/sponsor.actions";
import BankInfoMother from "./bank-info-mother";
import OrphanInfo from "./orphan-info";
import MainProvider from "./main-provider";
import FamilyHousing from "./family-housing";
import RequiredServices from "./required-services";
import IdentityPapers from "./identity-papers";
import Loader from "../../../biblio/Loader/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { getAllKorbaAssistance } from "../../../apis/actions/korba.actions";
import LiabilityData from "../recipient-form/family-liability-form";

const { TabPane } = Tabs;

const UpdateRecipient = () => {
  const [formBeneficiary] = Form.useForm();
  const [formOrphans] = Form.useForm();
  const [guardianForm] = Form.useForm();
  const [formHousing] = Form.useForm();
  const [formService] = Form.useForm();
  const [formDocs] = Form.useForm();
  const [formLiability] = Form.useForm();
  const { access_token } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [displayPrevious, setDisplayPrevious] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("1");
  const [completedTabs, setCompletedTabs] = useState<string[]>([]);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [beneficiryId, setBeneficiryId] = useState<number>(-1);
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [openedPanels, setOpenedPanels] = useState<boolean[]>([]);

  /** Mobile */
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  const handleCollapseChange = (key: string | string[]) => {
    const newOpenedPanels = [...openedPanels]; // Copy the current state
    if (Array.isArray(key)) {
      key.forEach((k) => {
        newOpenedPanels[parseInt(k)] = true; // Mark this panel as opened
      });
    } else {
      newOpenedPanels[parseInt(key)] = true; // Mark this single panel as opened
    }
    setOpenedPanels(newOpenedPanels); // Update state
    handleNextTab();
  };

  /** mobile end */
  const handleCheckboxChange = (e: any) => {
    setIsChecked(e.target.checked);
    formDocs.setFieldValue("declaration_accuracy", e.target.checked);
  };

  /** Use Selector part  */
  const { banks } = useSelector((state: RootState) => state.sponsor);
  const { korbaAssitances } = useSelector((state: RootState) => state.korbas);
  const {
    diseaseType,
    academicLevels,
    academicYears,
    academicsPerformance,
    educationalInstitutionTypes,
    identificationTypes,
    nationality,
    maritalStatus,
    orphansBeneficiaryInfo,
    healthStates,
    guardianRelationships,
    disabilityTypes,
    housingTypes,
    housingStates,
    loading,
  } = useSelector((state: RootState) => state.recipient);

  /** orphan gender filter */
  const maleOrphans =
    orphansBeneficiaryInfo &&
    orphansBeneficiaryInfo?.beneficiary_orphan_ids?.filter(
      (orphan: any) => orphan.gender === "male"
    );
  const femaleOrphans =
    orphansBeneficiaryInfo &&
    orphansBeneficiaryInfo?.beneficiary_orphan_ids?.filter(
      (orphan: any) => orphan.gender === "female"
    );

  /** navigate to next tab */
  const handleNextTab = async () => {
    try {
      const json = toFormatDataForApi();
      var data: any = null;
      switch (activeTab) {
        case "1":
          await formBeneficiary.validateFields();

          data = (await dispatch(toUpdateMotherBankInfo(json))) as any;

          break;
        case "2":
          await formOrphans.validateFields();
          let isValid = true;
          orphansBeneficiaryInfo?.beneficiary_orphan_ids?.forEach(
            (_: any, i: number) => {
              if (
                !formOrphans.getFieldValue(`health_state_id${i}`) ||
                // eslint-disable-next-line eqeqeq
                formOrphans.getFieldValue(`health_state_id${i}`) == ""
              ) {
                isValid = false;
              }
            }
          );

          if (isValid) {
            data = (await dispatch(toUpdateOrphansInfo(json))) as any;
          } else {
            showNotitfication("يجب تعبئة الحقول", "error");
          }

          break;
        case "3":
          await guardianForm.validateFields();
          data = (await dispatch(toUpdateGuardianInfo(json))) as any;
          break;
        case "4":
          await formHousing.validateFields();
          data = (await dispatch(toUpdateHousingInfo(json))) as any;
          break;
        case "5":
          await formLiability.validateFields();
          data = (await dispatch(toUpdateLiabilityInfos(json))) as any;
          break;
        case "6":
          await formService.validateFields();
          data = (await dispatch(toUpdateAssistancesInfo(json))) as any;
          break;
        case "7":
          await formDocs.validateFields();
          data = (await dispatch(toUpdateDocumentsInfo(json))) as any;
          break;
        default:
          break;
      }
      goNext(data);
    } catch (error) {
      console.error(error);
    }
  };

  /** navigate to prev tab */
  const handlePrevTab = () => {
    const prevTab = (parseInt(activeTab) - 1).toString();
    setActiveTab(prevTab);
  };

  /** check if tab is disabled */
  const isTabDisabled = (key: string): boolean => {
    return (
      key !== "1" && !completedTabs.includes((parseInt(key) - 1).toString())
    );
  };

  /** get all select values */

  useEffect(() => {
    if (orphansBeneficiaryInfo.is_deceased) {
      setActiveTab("2");
    }
  }, [orphansBeneficiaryInfo]);

  useEffect(() => {
    if (
      // eslint-disable-next-line eqeqeq
      (orphansBeneficiaryInfo.is_deceased && activeTab == "2") ||
      // eslint-disable-next-line eqeqeq
      (!orphansBeneficiaryInfo.is_deceased && activeTab == "1")
    ) {
      setDisplayPrevious(false);
    } else {
      setDisplayPrevious(true);
    }
  }, [activeTab, orphansBeneficiaryInfo]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(toGetAllBanks());
      await dispatch(getAllDiseaseType());
      await dispatch(getAllAcademicLevels());
      await dispatch(getAllAcademicsYears());
      await dispatch(getAllAcademicsPerformance());
      await dispatch(getAllEducationalInstitutionTypes());
      await dispatch(getAllIdentificationTypes());
      await dispatch(getAllNationality());
      await dispatch(getAllMaritalStatus());
      await dispatch(getAllOrphansBeneficiaryInfo(access_token));
      await dispatch(getAllHealthStates());
      await dispatch(getAllGuardianRelationships());
      await dispatch(getAllDisabilityTypes());
      await dispatch(getAllHousingTypes());
      await dispatch(getAllHousingStates());
      await dispatch(getAllKorbaAssistance());
    };
    fetchData().then(() => {
      setIsLoading(false);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const renderTabTitle = (
    key: string,
    activeIcon: React.ReactNode,
    inactiveIcon: React.ReactNode,
    title: string
  ) => {
    return (
      <span
        style={{ display: "flex", alignItems: "center", gap: "1vh" }}
        className={`${
          activeTab === key
            ? "takaful--recipient-tab-progress"
            : completedTabs.includes(key)
            ? "takaful--recipient-tab-completed"
            : ""
        }`}
      >
        {activeTab === key
          ? activeIcon
          : completedTabs.includes(key)
          ? inactiveIcon
          : activeIcon}
        {title}
      </span>
    );
  };

  const toFormatDataForApi = () => {
    switch (activeTab) {
      case "1":
        return {
          beneficiary_request_id: orphansBeneficiaryInfo.id,
          account_number: formBeneficiary.getFieldValue("account_number"),
          bank_id: formBeneficiary.getFieldValue("bank_id")?.value,
          account_owner: formBeneficiary.getFieldValue("account_owner"),
          widow_iban_image_ids: formBeneficiary.getFieldValue(
            "widow_iban_image_ids"
          ),
        };
      case "2":
        const data: any = [];
        orphansBeneficiaryInfo?.beneficiary_orphan_ids.forEach(
          (el: any, index: number) => {
            const item = {
              orphan_id: el.id,
              disease_type_ids:
                formOrphans
                  .getFieldValue(`disease_type_ids${index}`)
                  ?.map((el: any) => el.value) ?? [],
              disability_type_line_ids:
                formOrphans.getFieldValue(`disability_type_line_ids${index}`) ??
                [],
              familiarity_with_mobile:
                formOrphans.getFieldValue(`familiarity_with_mobile${index}`)
                  ?.value ?? "",
              proficient_in_braille:
                formOrphans.getFieldValue(`proficient_in_braille${index}`)
                  ?.value ?? "no",
              proficient_in_computing:
                formOrphans.getFieldValue(`proficient_in_computing${index}`)
                  ?.value ?? "",
              is_following_treatment:
                formOrphans.getFieldValue(`is_following_treatment${index}`) ??
                false,
              treatment_provider:
                formOrphans.getFieldValue(`treatment_provider${index}`) ?? "",
              not_continuing_treatment_reason:
                formOrphans.getFieldValue(
                  `not_continuing_treatment_reason${index}`
                ) ?? "",
              is_suffer_from_physical_disability:
                formOrphans.getFieldValue(
                  `is_suffer_from_physical_disability${index}`
                ) ?? "False",
              is_there_companion:
                formOrphans.getFieldValue(`is_there_companion${index}`) ??
                "False",
              aware_rights_duties:
                formOrphans.getFieldValue(`aware_rights_duties${index}`) ??
                "no",
              aware_organizations_provide_services:
                formOrphans.getFieldValue(
                  `aware_organizations_provide_services${index}`
                ) ?? "",
              account_number:
                formOrphans.getFieldValue(`account_number${index}`) ?? "",
              bank_id:
                formOrphans.getFieldValue(`bank_id${index}`)?.value ?? -1,
              account_owner:
                formOrphans.getFieldValue(`account_owner${index}`) ?? "",
              academic_level_id:
                formOrphans.getFieldValue(`academic_level_id${index}`)?.value ??
                -1,
              is_continuing_education:
                formOrphans.getFieldValue(`is_continuing_education${index}`) ??
                "",
              academic_year_id:
                formOrphans.getFieldValue(`academic_year_id${index}`)?.value ??
                -1,
              educational_institution:
                formOrphans.getFieldValue(`educational_institution${index}`) ??
                "",
              educational_institution_mobile:
                formOrphans.getFieldValue(
                  `educational_institution_mobile${index}`
                ) ?? "",
              educational_institution_type_id:
                formOrphans.getFieldValue(
                  `educational_institution_type_id${index}`
                )?.value ?? -1,
              educational_issues:
                formOrphans.getFieldValue(`educational_issues${index}`) ?? "",
              percentage_grade:
                formOrphans.getFieldValue(`percentage_grade${index}`) ?? "",
              tuition_fees:
                formOrphans.getFieldValue(`tuition_fees${index}`) ?? "",
              academic_performance_id:
                formOrphans.getFieldValue(`academic_performance_id${index}`)
                  ?.value ?? -1,
              health_state_id:
                formOrphans.getFieldValue(`health_state_id${index}`)?.value ??
                1,
            };
            // eslint-disable-next-line eqeqeq
            if (item.academic_level_id == -1) {
              delete item["academic_level_id"];
            }
            // eslint-disable-next-line eqeqeq
            if (item.academic_year_id == -1) {
              delete item["academic_year_id"];
            }
            // eslint-disable-next-line eqeqeq
            if (item.educational_institution_type_id == -1) {
              delete item["educational_institution_type_id"];
            }
            // eslint-disable-next-line eqeqeq
            if (item.academic_performance_id == -1) {
              delete item["academic_performance_id"];
            }
            // eslint-disable-next-line eqeqeq
            if (item.bank_id == -1) {
              delete item["bank_id"];
            }

            data.push(item);
          }
        );
        return {
          beneficiary_request_id: orphansBeneficiaryInfo.id,
          beneficiary_orphan_ids: data,
        };

      case "3":
        return {
          beneficiary_request_id: orphansBeneficiaryInfo.id,
          breadwinner_type: guardianForm.getFieldValue("breadwinner_type"),
          son_id: guardianForm.getFieldValue("son_id")?.value,
          breadwinner: guardianForm.getFieldValue("breadwinner")?.value,
          relative_relation_id: guardianForm.getFieldValue(
            "relative_relation_id"
          )?.value,
          guardian_name: guardianForm.getFieldValue("guardian_name"),
          guardian_identification: guardianForm.getFieldValue(
            "guardian_identification"
          ),
          guardian_email: guardianForm.getFieldValue("guardian_email"),
          rent_amount: guardianForm.getFieldValue("rent_amount"),
          guardian_nationality_id: guardianForm.getFieldValue(
            "guardian_nationality_id"
          )?.value,
          guardian_actual_profession: guardianForm.getFieldValue(
            "guardian_actual_profession"
          ),
          guardian_address: guardianForm.getFieldValue("guardian_address"),
          guardian_phone: guardianForm.getFieldValue("guardian_phone"),
          guardian_marital_status_id: guardianForm.getFieldValue(
            "guardian_marital_status_id"
          )?.value,
          guardian_account_number: guardianForm.getFieldValue(
            "guardian_account_number"
          ),
          guardian_bank_id:
            guardianForm.getFieldValue("guardian_bank_id")?.value,
          guardian_account_owner: guardianForm.getFieldValue(
            "guardian_account_owner"
          ),
          // guardian_acc_number_iban: guardianForm.getFieldValue(
          //   "guardian_acc_number_iban"
          // ),
          legal_guardian_image_ids: guardianForm.getFieldValue(
            "legal_guardian_image_ids"
          ),
          legal_agency_image_ids: guardianForm.getFieldValue(
            "legal_agency_image_ids"
          ),
          legal_guardian_iban_image_ids: guardianForm.getFieldValue(
            "legal_guardian_iban_image_ids"
          ),
        };

      case "4":
        return {
          beneficiary_request_id: orphansBeneficiaryInfo.id,
          housing_type_ids: formHousing.getFieldValue("housing_type_ids"),
        };

      case "5":
        return {
          beneficiary_request_id: orphansBeneficiaryInfo.id,
          liability_ids: formLiability.getFieldValue("liability_ids"),
        };
      case "6":
        return {
          beneficiary_request_id: orphansBeneficiaryInfo.id,
          beneficiary_assistance_ids: formService.getFieldValue(
            "beneficiary_assistance_ids"
          ),
        };
      case "7":
        return {
          beneficiary_request_id: orphansBeneficiaryInfo.id,
          family_record_image_1_ids: formDocs.getFieldValue(
            "family_record_image_1_ids"
          ),
          family_record_image_2_ids: formDocs.getFieldValue(
            "family_record_image_2_ids"
          ),
          family_record_image_3_ids: formDocs.getFieldValue(
            "family_record_image_3_ids"
          ),
        };
      default:
        break;
    }
  };

  const goNext = async (data: any) => {
    if (!data) return;
    const beneficiary = data?.payload?.data?.result;
    if (beneficiary?.code === 200) {
      showNotitfication(beneficiary?.message, "success");
      // eslint-disable-next-line eqeqeq
      if (activeTab == "1" && beneficiryId === -1) {
        setBeneficiryId(beneficiary.beneficiary_request_id);
      }
      if (
        (activeTab === "6" &&
          orphansBeneficiaryInfo.father_country_id !== "SA") ||
        (activeTab === "7" && orphansBeneficiaryInfo.father_country_id === "SA")
      ) {
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        const nextTab = (parseInt(activeTab) + 1).toString();
        setActiveTab(nextTab);
        if (!completedTabs.includes(activeTab)) {
          setCompletedTabs([...completedTabs, activeTab]);
        }
      }
    } else {
      showNotitfication(beneficiary?.message, "error");
    }
  };

  /** To get form values on change */
  const [, setFormValues] = useState({});
  const onValuesChange = (changedValues: any) => {
    setFormValues(changedValues);
  };

  if (isLoading) {
    return (
      <>
        <Loader />
      </>
    );
  }

  return (
    <>
      <NavBar variant="homePage" />
      <div className="takaful--add-recipient">
        <div className="takaful--add-recipient-title-image">
          <div className="takaful--title-tabs">
            <span>إستكمال البيانات</span>
          </div>
        </div>
        {isMobile ? (
          <div style={{ direction: "rtl" }}>
            <Collapse
              className="takaful--collapse-recipient"
              accordion
              defaultActiveKey="1"
              activeKey={activeTab}
              onChange={handleCollapseChange}
            >
              {!orphansBeneficiaryInfo.is_deceased && (
                <Collapse.Panel
                  disabled={isTabDisabled("1")}
                  className="takaful--header-recipient-Panel"
                  key="1"
                  header={
                    <div className="takaful--header-recipient-container">
                      <div className="takaful--header-recipient-collapse">
                        <img width={15} src={user} alt="users" />
                        <span className="takaful--add-recipient-title">
                          بيانات الحساب البنكي للأم
                        </span>
                      </div>
                    </div>
                  }
                >
                  <Form
                    form={formBeneficiary}
                    layout="vertical"
                    onValuesChange={onValuesChange}
                  >
                    <BankInfoMother banks={banks} form={formBeneficiary} />
                  </Form>
                  <div className="takaful--add-recipient-btn-container">
                    <SecondaryButton
                      title={activeTab === "7" ? "تسجيل" : "التالي"}
                      onClick={handleNextTab}
                      disabled={loading || (activeTab === "7" && !isChecked)}
                      loading={loading}
                    />
                    {displayPrevious && (
                      <PrimaryButton
                        title="السابق"
                        className="takaful--primary-button-prev"
                        onClick={handlePrevTab}
                        disabled={loading}
                      />
                    )}
                  </div>
                </Collapse.Panel>
              )}

              <Collapse.Panel
                className="takaful--header-recipient-Panel"
                key="2"
                disabled={isTabDisabled("2")}
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={20} src={users} alt="users" />
                      <span className="takaful--add-recipient-title">
                        بيانات أفراد الأسرة
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={formOrphans} layout="vertical">
                  <OrphanInfo
                    form={formOrphans}
                    diseaseType={diseaseType}
                    academicLevel={academicLevels}
                    academicYears={academicYears}
                    academicsPerformance={academicsPerformance}
                    educational={educationalInstitutionTypes}
                    orphansBeneficiaryInfo={orphansBeneficiaryInfo}
                    healthStates={healthStates}
                    disabilityTypes={disabilityTypes}
                    banks={banks}
                  />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "7" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "7" && !isChecked)}
                    loading={loading}
                  />
                  {displayPrevious && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>
              <Collapse.Panel
                disabled={isTabDisabled("3")}
                className="takaful--header-recipient-Panel"
                key="3"
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={15} src={location} alt="localtion" />
                      <span className="takaful--add-recipient-title">
                        العائل الرئيسي
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={guardianForm} layout="vertical">
                  <MainProvider
                    form={guardianForm}
                    identificationTypes={identificationTypes}
                    nationality={nationality}
                    maritalStatus={maritalStatus}
                    maleOrphans={maleOrphans}
                    femaleOrphans={femaleOrphans}
                    orphansBeneficiaryInfo={orphansBeneficiaryInfo}
                    guardianRelationships={guardianRelationships}
                    banks={banks}
                    formBank={formBeneficiary}
                  />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "7" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "7" && !isChecked)}
                    loading={loading}
                  />
                  {displayPrevious && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>

              <Collapse.Panel
                disabled={isTabDisabled("4")}
                className="takaful--header-recipient-Panel"
                key="4"
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={20} src={dollar} alt="money" />
                      <span className="takaful--add-recipient-title">
                        ممتلكات الأسرة
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={formHousing} layout="vertical">
                  <FamilyHousing
                    form={formHousing}
                    housingTypes={housingTypes}
                    housingStates={housingStates}
                  />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "7" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "7" && !isChecked)}
                    loading={loading}
                  />
                  {displayPrevious && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>
              <Collapse.Panel
                disabled={isTabDisabled("5")}
                className="takaful--header-recipient-Panel"
                key="5"
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={20} src={tab} alt="folder" />
                      <span className="takaful--add-recipient-title">
                        الإلتزامات الجّارية
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={formLiability} layout="vertical">
                  <LiabilityData form={formLiability} />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "7" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "7" && !isChecked)}
                    loading={loading}
                  />
                  {displayPrevious && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>
              <Collapse.Panel
                disabled={isTabDisabled("6")}
                className="takaful--header-recipient-Panel"
                key="6"
                header={
                  <div className="takaful--header-recipient-container">
                    <div className="takaful--header-recipient-collapse">
                      <img width={20} src={dollar} alt="money" />
                      <span className="takaful--add-recipient-title">
                        الخدمات المطلوبة
                      </span>
                    </div>
                  </div>
                }
              >
                <Form form={formService} layout="vertical">
                  <RequiredServices
                    form={formService}
                    korbaAssitances={korbaAssitances}
                  />
                </Form>
                <div className="takaful--add-recipient-btn-container">
                  <SecondaryButton
                    title={activeTab === "7" ? "تسجيل" : "التالي"}
                    onClick={handleNextTab}
                    disabled={loading || (activeTab === "7" && !isChecked)}
                    loading={loading}
                  />
                  {displayPrevious && (
                    <PrimaryButton
                      title="السابق"
                      className="takaful--primary-button-prev"
                      onClick={handlePrevTab}
                      disabled={loading}
                    />
                  )}
                </div>
              </Collapse.Panel>

              {orphansBeneficiaryInfo.father_country_id === "SA" && (
                <Collapse.Panel
                  disabled={isTabDisabled("7")}
                  className="takaful--header-recipient-Panel"
                  key="7"
                  header={
                    <div className="takaful--header-recipient-container">
                      <div className="takaful--header-recipient-collapse">
                        <img width={20} src={folder} alt="folder" />
                        <span className="takaful--add-recipient-title">
                          الأوراق الثبوتية
                        </span>
                      </div>
                    </div>
                  }
                >
                  <Form form={formDocs} layout="vertical">
                    <IdentityPapers form={formDocs} />
                    <Row
                      gutter={16}
                      style={{ paddingTop: "-5rem", paddingRight: "2rem" }}
                    >
                      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Form.Item
                          name="declaration_accuracy"
                          valuePropName="declaration_accuracy"
                        >
                          <Checkbox onChange={handleCheckboxChange}>
                            <span className="takaful--check-style">
                              الإقرار بأن جميع البينات صحيحة
                            </span>
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                  <div className="takaful--add-recipient-btn-container">
                    <SecondaryButton
                      title={
                        (activeTab === "6" &&
                          orphansBeneficiaryInfo.father_country_id !== "SA") ||
                        (activeTab === "7" &&
                          orphansBeneficiaryInfo.father_country_id === "SA")
                          ? "تسجيل"
                          : "التالي"
                      }
                      onClick={handleNextTab}
                      disabled={loading || (activeTab === "7" && !isChecked)}
                      loading={loading}
                    />
                    {displayPrevious && (
                      <PrimaryButton
                        title="السابق"
                        className="takaful--primary-button-prev"
                        onClick={handlePrevTab}
                        disabled={loading}
                      />
                    )}
                  </div>
                </Collapse.Panel>
              )}
            </Collapse>
          </div>
        ) : (
          <>
            <Tabs
              style={{ marginTop: "-50px" }}
              activeKey={activeTab}
              onChange={setActiveTab}
              direction="rtl"
            >
              {!orphansBeneficiaryInfo.is_deceased && (
                <TabPane
                  tab={renderTabTitle(
                    "1",
                    <img width={15} src={user} alt="users" />,
                    <img width={15} src={userWhite} alt="users" />,
                    "بيانات الحساب البنكي للأم"
                  )}
                  key="1"
                  disabled={isTabDisabled("1")}
                >
                  <Form
                    form={formBeneficiary}
                    layout="vertical"
                    onValuesChange={onValuesChange}
                  >
                    <BankInfoMother banks={banks} form={formBeneficiary} />
                  </Form>
                </TabPane>
              )}

              <TabPane
                tab={renderTabTitle(
                  "2",
                  <img width={20} src={users} alt="users" />,
                  <img width={20} src={usersWhite} alt="users" />,
                  "بيانات أفراد الأسرة"
                )}
                key="2"
                disabled={isTabDisabled("2")}
              >
                <Form form={formOrphans} layout="vertical">
                  <OrphanInfo
                    form={formOrphans}
                    diseaseType={diseaseType}
                    academicLevel={academicLevels}
                    academicYears={academicYears}
                    academicsPerformance={academicsPerformance}
                    educational={educationalInstitutionTypes}
                    orphansBeneficiaryInfo={orphansBeneficiaryInfo}
                    healthStates={healthStates}
                    disabilityTypes={disabilityTypes}
                    banks={banks}
                  />
                </Form>
              </TabPane>

              <TabPane
                tab={renderTabTitle(
                  "3",
                  <img width={15} src={location} alt="localtion" />,
                  <img width={20} src={locationWhite} alt="localtion" />,
                  "العائل الرئيسي"
                )}
                key="3"
                disabled={isTabDisabled("3")}
              >
                <Form form={guardianForm} layout="vertical">
                  <MainProvider
                    form={guardianForm}
                    identificationTypes={identificationTypes}
                    nationality={nationality}
                    maritalStatus={maritalStatus}
                    maleOrphans={maleOrphans}
                    femaleOrphans={femaleOrphans}
                    orphansBeneficiaryInfo={orphansBeneficiaryInfo}
                    guardianRelationships={guardianRelationships}
                    banks={banks}
                    formBank={formBeneficiary}
                  />
                </Form>
              </TabPane>

              <TabPane
                tab={renderTabTitle(
                  "4",
                  <img width={20} src={dollar} alt="money" />,
                  <img width={20} src={dollarWhite} alt="money" />,
                  "ممتلكات الأسرة"
                )}
                key="4"
                disabled={isTabDisabled("4")}
              >
                <Form form={formHousing} layout="vertical">
                  <FamilyHousing
                    form={formHousing}
                    housingTypes={housingTypes}
                    housingStates={housingStates}
                  />
                </Form>
              </TabPane>
              <TabPane
                tab={renderTabTitle(
                  "5",
                  <img width={20} src={tab} alt="folder" />,
                  <img width={20} src={tab} alt="folder" />,
                  "الإلتزامات الجّارية"
                )}
                key="5"
                disabled={isTabDisabled("5")}
              >
                <Form form={formLiability} layout="vertical">
                  <LiabilityData form={formLiability} />
                </Form>
              </TabPane>
              <TabPane
                tab={renderTabTitle(
                  "6",
                  <img width={20} src={folder} alt="folder" />,
                  <img width={20} src={folder} alt="folder" />,
                  "الخدمات المطلوبة"
                )}
                key="6"
                disabled={isTabDisabled("6")}
              >
                <Form form={formService} layout="vertical">
                  <RequiredServices
                    form={formService}
                    korbaAssitances={korbaAssitances}
                  />
                </Form>
              </TabPane>
              {orphansBeneficiaryInfo.father_country_id === "SA" && (
                <TabPane
                  tab={renderTabTitle(
                    "7",
                    <img width={20} src={folder} alt="folder" />,
                    <img width={20} src={folder} alt="folder" />,
                    "الأوراق الثبوتية"
                  )}
                  key="7"
                  disabled={isTabDisabled("7")}
                >
                  <Form form={formDocs} layout="vertical">
                    <IdentityPapers form={formDocs} />
                    <Row
                      gutter={16}
                      style={{ paddingTop: "-5rem", paddingRight: "2rem" }}
                    >
                      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                        <Form.Item
                          name="declaration_accuracy"
                          valuePropName="declaration_accuracy"
                        >
                          <Checkbox onChange={handleCheckboxChange}>
                            <span className="takaful--check-style">
                              الإقرار بأن جميع البينات صحيحة
                            </span>
                          </Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </TabPane>
              )}
            </Tabs>
            <div className="takaful--add-recipient-btn-container">
              <SecondaryButton
                title={
                  (activeTab === "6" &&
                    orphansBeneficiaryInfo.father_country_id !== "SA") ||
                  (activeTab === "7" &&
                    orphansBeneficiaryInfo.father_country_id === "SA")
                    ? "تسجيل"
                    : "التالي"
                }
                onClick={handleNextTab}
                disabled={loading || (activeTab === "7" && !isChecked)}
                loading={loading}
              />
              {displayPrevious && (
                <PrimaryButton
                  title="السابق"
                  className="takaful--primary-button-prev"
                  onClick={handlePrevTab}
                  disabled={loading}
                />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default UpdateRecipient;
